import * as Yup from "yup";
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
// const IRANphoneRegExp = /^9\d{9}$/g
const IRANphoneRegExp = /^(\+98|0)?9\d{9}$/;

const mobile = Yup.string()
  .label("mobile")
  .matches(phoneRegExp, "شماره وارد شده صحیح نمی باشد")
  .required("وارد کردن شماره موبایل الزامی است");
const IRANmobile = Yup.string()
  .label("mobile")
  .matches(IRANphoneRegExp, "شماره وارد شده صحیح نمی باشد")
  .required("وارد کردن شماره موبایل الزامی است");
const email = Yup.string()
  .email("ایمیل وارد شده صحیح نمی باشد")
  .required("وارد کردن ایمیل الزامی است");
const pass = Yup.string()
  .label("pass")
  .min(8, "رمز عبور باید حاقل 8 کاراکتر باشد")
  .required("وارد کردن رمز عبور الزامی است");

const firstName = Yup.string()
  .label("firstName")
  .min(3, "حداقل تعداد کاراکتر مجاز 3 می باشد")
  .max(20, "حداکثر تعداد کاراکتر مجاز 20 می باشد")
  .required("وارد کردن نام الزامی است");
const lastName = Yup.string()
  .label("lastName")
  .min(3, "حداقل تعداد کاراکتر مجاز 3 می باشد")
  .max(20, "حداکثر تعداد کاراکتر مجاز 20 می باشد")
  .required("وارد کردن نام خانوادگی الزامی است");
const timezone = Yup.string()
  .label("timezone")
  .required("ساعت محلی خود را تعیین کنید");
const phoneCode = Yup.string()
  .label("phoneCode")
  .required("کد کشور خود را انتخاب کنید");
const price = Yup.number("قیمت وارد شده صحیح نیست")
  .label("price")
  .min(0, "حداقل قیمت مجاز صفر می باشد")
  .max(500000, "حداقل قیمت مجاز 500 هزار تومان می باشد")
  // .negative('قیمت وارد شده صحیح نیست')
  // .lessThan(0, 'حداقل قیمت مجاز صفر می باشد')
  .required("این فیلد الزامی است.");

export const SingleSessionPriceSchema = Yup.object().shape({
  price,
});
export const LoginByEmailSchema = Yup.object().shape({
  email,
  pass,
});
const CheckMobile = (code) => {
  return code === "+98" ? IRANmobile : mobile;
};
export const LoginByMobileSchema = (code) => {
  return Yup.object().shape({
    mobile: CheckMobile(code),
    pass,
    phoneCode,
  });
};

export const SendVerifyCodeByMobileSchema = (code) => {
  return Yup.object().shape({
    mobile: CheckMobile(code),
    firstName,
    lastName,
    pass,
    phoneCode,
    timezone,
  });
};

export const SendVerifyCodeByEmailSchema = Yup.object().shape({
  email,
  firstName,
  lastName,
  pass,
  timezone,
});
export const TeacherRegisterSchema = (code) => {
  return Yup.object().shape({
    mobile: CheckMobile(code),
    firstName,
    lastName,
    pass,
    phoneCode,
    timezone,
  });
};
export const ForgotPasswordByPhoneSchema = (code) => {
  return Yup.object().shape({
    mobile: CheckMobile(code),
    pass,
  });
};

export const ForgotPasswordByEmailSchema = Yup.object().shape({
  email,
  pass,
});
export const NewPasswordSchema = Yup.object().shape({
  pass,
});
export const UpdatePasswordSchema = Yup.object().shape({
  // currentPass : pass,
  // newPass : pass
});
